import React from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { INDUSTRIES } from "components/tmisc/get_started/GetStarted.lib.catalogs";
import l from "components/util/l";

const GetStartedView = ({
  formData,
  isLoading,
  percent,
  totalSteps,
  totalPhases,
  updateFormData,
  onClickBackStep,
  onClickNextStep,
  onClickFinish,
}) => {

  const {
    step,
    area,
    error,
    position,
    industry,
    useManual,
    company_url,
    services,
  } = formData;

  return (
    <div className="container-fluid px-0">
      <div className="row">

        {/* LEFT SIDE */}
        <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center min-vh-lg-100 position-relative px-0 ">
          <div
            className="position-absolute top-0 right-0 left-0 bg-img-hero w-100 h-100"
            id="background-hero"
          >
            <figure className="position-absolute top-0 right-0 left-0 overflow-hidden">
              <svg
                preserveAspectRatio="none"
                viewBox="0 0 1920 698"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                transform="rotate(270)"
                style={{ height: "132vh", width: "132vh" }}
              >
                <rect width="1920" height="698" fill="#fff" />
                <g clipPath="url(#clip0)">
                  <path
                    className="path-a"
                    d="M1920 -714.403H0V1412.4H1920V-714.403Z"
                    fill="#2065a5"
                  />
                  <path
                    className="path-b"
                    d="M1298.9 -5488.72L2618.5 1300.02L1702.8 1842.02C1651.6 1690.56 1569.6 1565.26 1479.9 1480.46C1338.1 1346.44 1176.9 1292.52 1020.9 1221.67C933 1182.06 832 1111.56 811.9 957.132C799 858.54 824.8 759.075 837.2 660.308C869.8 400.128 798.7 110.284 668.3 -28.0949C635.9 -62.4714 599.1 -90.391 577.4 -144.661C510.4 -312.18 639.3 -526.467 627 -729.759C622.6 -803.224 599.6 -869.01 574.6 -928.689C300.4 -1585.86 -209.4 -1749.54 -628.8 -2103.6C-751.2 -2207.08 -871.1 -2334.11 -955 -2520.83C-1038.9 -2707.72 -1081.4 -2964.58 -1036.1 -3188.29C-974.1 -3494.19 -776.5 -3644.26 -593.7 -3703.76C-410.9 -3763.27 -215.6 -3771.47 -56 -3937.77C117.6 -4118.72 216 -4451.32 351 -4713.77C418.6 -4845.17 495.6 -4958.94 577.8 -5061.9L1298.9 -5488.72Z"
                    fill="#205595"
                  />
                  <path
                    className="path-c"
                    d="M1733.2 -6299.97L3053 487.553L2137.2 1029.55C2086 878.084 2004 752.968 1914.3 668.161C1772.5 534.145 1611.3 480.224 1455.2 409.552C1367.3 369.766 1266.3 299.443 1246.2 145.01C1233.4 46.4176 1259.2 -53.0476 1271.5 -151.815C1304.1 -411.994 1233 -701.664 1102.6 -840.217C1070.2 -874.594 1033.4 -902.514 1011.7 -956.783C944.7 -1124.3 1073.6 -1338.59 1061.3 -1541.71C1056.9 -1615.17 1033.8 -1680.96 1008.9 -1740.64C734.8 -2397.63 224.9 -2561.31 -194.5 -2915.37C-316.9 -3018.85 -436.8 -3145.71 -520.7 -3332.6C-604.6 -3519.32 -647.1 -3776.18 -601.8 -3999.89C-539.8 -4305.61 -342.2 -4455.86 -159.4 -4515.36C23.3999 -4574.87 218.7 -4583.07 378.3 -4749.37C551.8 -4930.15 650.2 -5262.75 785.2 -5525.02C852.8 -5656.42 929.8 -5770.19 1012 -5873.15L1733.2 -6299.97Z"
                    fill="#104a8a"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="1920" height="698" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </figure>
          </div>

          <div className="position-absolute top-0 left-0 right-0 mt-4 mx-5">
            <div className="d-none d-lg-flex justify-content-between">
              <a href="/">
                <img
                  className="w-100"
                  src="/theme/svg/logos/logo-white.svg"
                  alt="Workix logo"
                  style={{ minWidth: "10rem", maxWidth: "10rem" }}
                />
              </a>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-lg-8 d-flex justify-content-center align-items-start align-items-md-center vh-100 overflow-auto">
          <div className="w-100 pt-8 pt-lg-7 pb-7" style={{ maxWidth: "52rem" }}>
            <form onSubmit={e => {
              e.preventDefault();
              step < totalSteps ? onClickNextStep() : onClickFinish()
            }}>
              <div className="text-center mb-5">
                <h1 className="display-4">{l("¡Bienvenido a Workix!%GS001")}</h1>
                <p>{l("Transforma tu organización con inteligencia artificial%GS002")}</p>
              </div>

              <div className="card">
                <div className="card-header mb-2 pb-0">
                  {/* Progress */}
                  <div className="mb-4 w-100">
                    <div className="d-flex justify-content-between mb-1">
                      <small className="text-muted">{l("Progreso%GS003")}</small>
                      <small className="text-muted">
                        {step} {l("de%GS004")} {totalPhases}
                      </small>
                    </div>
                    <div className="progress" style={{ height: 6 }}>
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: `${percent}%` }}
                        aria-valuenow={percent}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      />
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  {(() => {
                    switch (step) {
                      case 1:
                        return (
                          <FirstStep
                            useManual={useManual}
                            company_url={company_url}
                            industry={industry}
                            services={services}
                            updateFormData={updateFormData}
                          />
                        );
                      case 2:
                        return <SecondStep
                          area={area}
                          position={position}
                          updateFormData={updateFormData}
                        />;
                      default:
                        return null;
                    }
                  })()}
                </div>

                {error &&
                  <div className="px-4 pb-2">
                    <div className="alert alert-soft-danger mb-0 py-2" role="alert">
                      {error}
                    </div>
                  </div>}

                <div className="card-footer d-flex justify-content-between align-items-center">
                  <button
                    type="button"
                    className="btn btn-link"
                    onClick={onClickBackStep}
                    style={{ visibility: step > 1 ? "visible" : "hidden" }}
                    disabled={isLoading}
                  >
                    {l("Volver%GA036")}
                  </button>
                  <div>

                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isLoading}
                    >
                      {isLoading ?
                        <span><i className="fa fa-spinner fa-spin mr-2" aria-hidden="true"></i>
                          {step == 1 && !useManual ? l("Analizando página%GS517") : l("Analizando%GS516")}</span> :
                        step < totalSteps ? l("Siguiente%GA039") : l("Descubre tu solución%GS515")}
                    </button>

                  </div>
                </div>
              </div>

            </form>
          </div>

        </div>
      </div>
    </div>
  );

}

const FirstStep = ({
  useManual,
  company_url,
  industry,
  services,
  updateFormData,
}) =>
  <>
    <h3 className="mb-1 text-center">
      {l("Cuéntanos sobre tu empresa%GS468")}
    </h3>
    <p className="text-muted mb-4 text-center">
      {l("Usaremos la información para diseñar la mejor solución para ti%GS498")}
    </p>

    {!useManual ? (
      <div className="form-group mb-4">
        <label>{l("URL de tu empresa%GS470")}</label>
        <input
          type="url"
          className="form-control"
          placeholder={l("Ej. https://www.miempresa.com%GS471")}
          value={company_url}
          onChange={(e) => updateFormData({ company_url: e.target.value })}
        />
        <div className="d-flex justify-content-between align-items-center mt-2">
          <small className="text-muted">
            {l("Usaremos la URL para entender mejor tu negocio.%GS472")}
          </small>
          <button
            type="button"
            className="btn btn-sm btn-link"
            onClick={() => updateFormData({ useManual: true })}
          >
            {l("Indicar manualmente%GS473")}
          </button>
        </div>
      </div>
    ) : (
      <>
        <div className="d-flex justify-content-end align-items-center mb-3">
          {/* Temp hide 251118
          <button
            type="button"
            className="btn btn-sm btn-link"
            onClick={() => updateFormData({ useManual: false })}
          >
            {l("Usar URL de mi empresa%GS475")}
          </button>
          */}
        </div>

        <div className="border rounded p-3 bg-light">
          <div className="form-group mb-3">
            <label className="mb-1">
              {l("Industria principal%GS476")}<small className='text-danger ml-1'>*</small>
            </label>
            {/* Only a picked option is kept: what is typed filters the list and nothing
                else, so the industry always lands as one of the catalog's. */}
            <Typeahead
              id="industry-typeahead"
              options={INDUSTRIES}
              placeholder={l("Ej. Manufactura, Tecnología / Software, Banca y Finanzas%GS922")}
              emptyLabel={l("Sin coincidencias. Elige la más cercana u Otra industria%GS923")}
              minLength={0}
              onChange={(selected) => updateFormData({ industry: selected[0] || "" })}
              selected={industry ? [industry] : []}
            />
          </div>

          <div className="form-group mb-0">
            <label className="mb-1">
              {l("Servicios que ofrece tu empresa%GS478")}<small className='text-danger ml-1'>*</small>
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder={l("Ej. Servicios de consultoría, renta de maquinaria%GS479")}
                value={services}
                required
                onChange={(e) => {
                  updateFormData({ services: e.target.value });
                }}
              />
            </div>

          </div>
        </div>
      </>
    )}
  </>;

// Name and email left this step: the assistant asks for them at the end, and only when it
// needs to. What is left is what the assistant needs to speak the visitor's language.
const SecondStep = ({
  area,
  position,
  updateFormData,
}) =>
  <>
    <h3 className="mb-4 text-center">
      {l("Cuéntanos sobre ti%GS485")}
    </h3>
    <div className="border rounded p-3 bg-light">
      <div className="form-group mb-3">
        <label className="mb-1">
          {l("Área en la que trabajas%GS486")}<small className='text-danger ml-1'>*</small>
        </label>
        <input
          type="text"
          className="form-control"
          required
          placeholder={l("Ej. Operaciones, ventas, dirección, RRHH%GS487")}
          value={area}
          onChange={(e) => updateFormData({ area: e.target.value })}
        />
      </div>
      {
        <div className="form-group mb-0">
          <label className="mb-1">
            {l("Puesto%GS496")}<small className='ml-1' style={{ color: "#a0a5b0" }}>(Opcional)</small>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder={l("Ej. Gerente de recursos humanos, analista de marketing%GS497")}
            value={position}
            onChange={(e) => updateFormData({ position: e.target.value })}
          />
        </div>
      }
    </div>
  </>;

export default GetStartedView;